import get from 'lodash/get'
import intersection from 'lodash/intersection'
import {createSelector} from 'reselect'
import {someEmpty} from '../utils'
import i18n from '../i18n'

const getAvailableCategories = state => state.availableCategories
const getCategories = state => state.categories
const getPrices = state => state.prices

export const selectCategories = createSelector(
    getAvailableCategories,
    getCategories,
    getPrices,
    (availableCategories, categories, prices) => {
        if (!someEmpty([availableCategories.entities, categories.entities, prices.entities])) {
            const availableCategoriesEntities = availableCategories.entities.availableCategories
            const categoriesEntities = categories.entities.categories
            const pricesEntities = prices.entities.prices

            const categoryIds = intersection(availableCategories.result, categories.result, prices.result) // prices can contain category ids, that are not included in availableCategories

            return categoryIds.map(id => ({
                id,
                availability: availableCategoriesEntities[id].availability,
                name: get(categoriesEntities[id], 'name', availableCategoriesEntities[id].categoryName),
                description: get(categoriesEntities[id], 'description', i18n.t('categoriesSelector.nodescription')),
                images: get(categoriesEntities[id], 'images', []),
                price: get(pricesEntities[id], 'value', 0),
                currency: prices.currency
            }))
        } else return []
    }
)

export const selectIsFetching = createSelector(
    getAvailableCategories,
    getCategories,
    getPrices,
    (availableCategories, categories, prices) =>
        availableCategories.isFetching || categories.isFetching || prices.isFetching
)



// WEBPACK FOOTER //
// ./selectors/categoriesSelector.js